import { IconCheck } from '@tabler/icons-react';
import { m } from '@/locale/paraglide/messages';
import Container from '@/components/layout/container';
import { DashboardHeader } from '@/components/layout/dashboard-header';
import {
  PricingFaqSection,
  PublicCreditPackages,
} from '@/components/pricing/public-credit-packages';
import { websiteConfig } from '@/config/website';
import { seo } from '@/lib/seo';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/(pages)/pricing')({
  validateSearch: (search: Record<string, unknown>) => ({
    returnTo: typeof search.returnTo === 'string' ? search.returnTo : undefined,
  }),
  head: () =>
    seo('/pricing', {
      title: `${m.pricing_title()} | ${websiteConfig.metadata?.name}`,
      description: m.pricing_description(),
    }),
  component: PricingPage,
});

function PricingPage() {
  const { returnTo } = Route.useSearch();
  const trust = [
    m.pricing_trust_one_time(),
    m.pricing_trust_never_expire(),
    m.pricing_trust_refunds(),
    m.pricing_trust_secure(),
  ];
  return (
    <div className="dark flex min-h-svh flex-col bg-[#090909]">
      <DashboardHeader showBack showSidebarTrigger={false} />
      <Container className="px-4 py-14 text-white sm:py-20">
        <div className="mx-auto max-w-5xl space-y-10">
          <div className="space-y-4 text-center">
            <p className="font-semibold text-[#8ef25a] text-xs uppercase tracking-[0.2em]">
              {m.pricing_eyebrow()}
            </p>
            <h1 className="font-bold font-sans text-4xl tracking-tight sm:text-5xl">
              {m.pricing_title()}
            </h1>
            <p className="mx-auto max-w-2xl text-base text-white/65 leading-7 sm:text-lg">
              {m.pricing_subtitle()}
            </p>
          </div>
          <PublicCreditPackages returnUrl={returnTo} />
          <ul className="grid gap-3 text-sm text-white/70 sm:grid-cols-2 lg:grid-cols-4">
            {trust.map((item) => (
              <li
                key={item}
                className="flex items-center gap-2 rounded-xl border border-white/10 bg-white/[0.03] px-4 py-3"
              >
                <IconCheck className="size-4 shrink-0 text-[#8ef25a]" />
                {item}
              </li>
            ))}
          </ul>
          <PricingFaqSection />
        </div>
      </Container>
    </div>
  );
}
